import { LogLevel } from "@azure/msal-browser"



export const msalConfig = {
  
    auth: {
        // clientId: "89db3d01-750d-4e25-ae35-5b1e610bf3b8",
        clientId: "23daa672-26dd-470d-b081-5db9d0ec2fdd",
        authority: `https://login.microsoftonline.com/04527940-52a6-4f78-9bc4-253f9546b748`,
        redirectUri:`${window.location.protocol}//${window.location.host}`,
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
};

export const loginRequest = {
    scopes: ["User.Read"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};